// import { Redirect } from "react-router-dom"
import { all, call, fork, put, takeEvery } from "redux-saga/effects"
import { getCountryListApi } from "../../services/Api/CountryListApi";
import { getCountryList,getErrors } from "../reducers/CountryListReducer";
 

// Watchers
function* countryListSaga() {
	yield takeEvery("country_list/getCountry", getAllCountry)
}

// Sagas
function* getAllCountry(action) {
   
	// console.log(action.payload);
	try {
		const getCountry = yield call(getCountryListApi, action.payload)
      
       
		if (getCountry.request.status === 200) {
			yield put(getCountryList(getCountry))
		} else {
			yield put(getErrors(getCountry))
		}
	} catch (error) {
		
		yield put(getErrors(error))
	}
}

export default function* rootSaga() {
	yield all([fork(countryListSaga)])
}
